<template>
  <div class="lc-input-identity-card">
    <el-input
      v-model="val"
      :minLength="minLength"
      :maxLength="maxLength"
      :clearable="clearable"
      :placeholder="placeholder"
      @input.native="handleInput"
      @blur="handleBlur"
    ></el-input>
    <div class="lc-validate-icon" v-show="validateMark === -1">
      {{ errorNotice }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'LcInputIdentityCard',
  props: {
    value: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    errorNotice: {
      type: String,
      default: '身份证号格式错误'
    }
  },
  data() {
    return {
      val: '',
      minLength: 15,
      maxLength: 18,
      regIdentityCard18: /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
      regIdentityCard15: /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/,
      validateMark: 0, // 0未校验 1格式正确 -1格式错误
    };
  },
  created() {
    this.val = this.value
  },
  methods: {
    handleInput(e) {
      this.validateMark = 0
      if (isNaN(e.data) && e.data !== "X") {
        this.val = this.val.slice(0, -1);
      }
      this.$emit('input', this.val)
    },
    handleBlur() {
      const val = this.val;
      if (new RegExp(this.regIdentityCard18).test(val) || new RegExp(this.regIdentityCard15).test(val)) {
        this.validateMark = 1
      } else {
        this.validateMark = -1
      }
    },
  },
};
</script>
<style lang="scss">
.lc-input-identity-card {
  display: inline-block;
  position: relative;
  .lc-validate-icon {
    position: absolute;
    top: 100%;
    left: 0;
    padding-top: 4px;
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
  }
}
</style>